import React, { useContext } from 'react';
import {
  CardTitle,
  CardValueTitle,
} from 'spw-programming-projects/program-summary/components/styles';
import { Box, Grid } from '@mui/material';
import {
  CardBoldValue,
  SmallCard,
  SmallCardRow,
  CardBoldSmallValue,
} from 'spw-components/project-details-tabs/program-summary/esa-single-page-summary/styles';
import { NO_DATA_TO_SHOW } from 'spw-constants';
import { asUsf } from 'spw-shared/utils';
import { ProgramSummaryCardsContext } from 'spw-esa-projects/program-summary/summary-cards';
import { useSelector } from 'react-redux';
import {
  selectKeyData,
  selectSeatCountRsfWithWorkpoints,
  selectTotalWorkpoints,
} from 'spw-redux/modules/program-summary/esa/selectors';
import { Row } from 'spw-shared/globalComponents/grid';
import useUnitConversion from 'spw-components/unit-conversion/hooks';
import { ProgramSummaryCardType } from 'spw-esa-projects/program-summary/icon-selector-popover';
import CardIcon from 'spw-esa-projects/program-summary/card-icon';
import { useCardIcon } from 'spw-esa-projects/program-summary/cards/hooks';

const SeatCountUSFWithWorkpoints = () => {
  const { getUnit, convertArea } = useUnitConversion();
  const { showRsf, selectedCardIcon, onClickCardIcon } = useContext(
    ProgramSummaryCardsContext
  );
  const seatCountRsfWithWorkpoints = useSelector(
    selectSeatCountRsfWithWorkpoints
  );
  const totalWorkpoints = useSelector(selectTotalWorkpoints);
  const keyData = useSelector(selectKeyData);

  const seatCountUsf = keyData.total / totalWorkpoints;
  const cardIcon = useCardIcon(
    ProgramSummaryCardType.seatCountUsfRsfWorkpoints
  );

  const handleIconClick = (event: React.MouseEvent<HTMLDivElement>) => {
    onClickCardIcon(event, cardIcon);
  };

  const isIconCardSelected =
    selectedCardIcon?.cardType ===
    ProgramSummaryCardType.seatCountUsfRsfWorkpoints;

  if (!cardIcon) return null;

  return (
    <>
      {showRsf ? (
        <SmallCard $tall display="flex" flexDirection="column">
          <CardTitle style={{ marginBottom: 8 }}>
            Seat Count {getUnit('rentable-area')} + {getUnit('area')}
          </CardTitle>
          <Grid container alignItems="center" spacing={4}>
            <Grid item xs={12}>
              <Row alignItems="center" mb={0.5}>
                <Box height={32} pr={1}>
                  <CardIcon
                    iconPath={`/images/program-summary/${cardIcon.iconPath}-small`}
                    onClick={handleIconClick}
                    isSelected={isIconCardSelected}
                    isSmallIcon
                  />
                </Box>

                <CardBoldSmallValue
                  style={{ marginBottom: 0 }}
                  warning={
                    seatCountRsfWithWorkpoints < Math.round(seatCountUsf)
                  }
                >
                  {seatCountRsfWithWorkpoints
                    ? asUsf(convertArea(seatCountRsfWithWorkpoints))
                    : NO_DATA_TO_SHOW}
                </CardBoldSmallValue>
              </Row>

              <CardValueTitle style={{ marginBottom: 16 }}>
                {getUnit('rentable-area')} /<br />
                Work Seats + Alt Workpoints
              </CardValueTitle>

              <Row alignItems="center" mb={0.5}>
                <Box height={32} pr={1}>
                  <CardIcon
                    iconPath={`/images/program-summary/${cardIcon.iconPath}-small`}
                    onClick={handleIconClick}
                    isSelected={isIconCardSelected}
                    isSmallIcon
                  />
                </Box>

                <CardBoldSmallValue style={{ marginBottom: 0 }}>
                  {seatCountUsf
                    ? asUsf(convertArea(seatCountUsf))
                    : NO_DATA_TO_SHOW}
                </CardBoldSmallValue>
              </Row>

              <CardValueTitle>
                {getUnit('area')} /<br />
                Work Seats + Alt Workpoints
              </CardValueTitle>
            </Grid>
          </Grid>
        </SmallCard>
      ) : (
        <SmallCard $tall display="flex" flexDirection="column">
          <CardTitle style={{ marginBottom: 0 }}>
            Seat Count {getUnit('area')}
          </CardTitle>
          <Grid container flexGrow={1} alignItems="center">
            <Grid item xs={12}>
              <SmallCardRow display="flex">
                <Box mr={2.5} ml={0.5}>
                  <CardIcon
                    iconPath={`/images/space-icons/${cardIcon.iconPath}`}
                    onClick={handleIconClick}
                    height={36}
                    isSelected={isIconCardSelected}
                  />
                </Box>
                <CardBoldValue>
                  {seatCountUsf
                    ? asUsf(convertArea(seatCountUsf))
                    : NO_DATA_TO_SHOW}
                </CardBoldValue>
              </SmallCardRow>
              <CardValueTitle>
                {getUnit('area')} /<br />
                Work Seats + Alt Workpoints
              </CardValueTitle>
            </Grid>
          </Grid>
        </SmallCard>
      )}
    </>
  );
};

export default SeatCountUSFWithWorkpoints;
